export function isHex (colorStr: string) {
  return /^#([A-Fa-f0-9]{3}){1,2}$/.test(colorStr);
}
